import React from 'react'

import { Text } from '@wartek-id/text'

interface TextMateriContentProps {
  title: string
  content: string
  isDesktop?: boolean
}

const TextMateriContent = ({
  title,
  content,
  isDesktop = false,
}: TextMateriContentProps) => {
  return (
    <div
      className="p-4 bg-white border border-subduedrounded-lg overflow-y-auto"
      style={{
        height: `calc(100vh - ${isDesktop ? 16 : 9.5}rem)`,
      }}
    >
      <div className="mb-[14px] leading-relaxed">
        <Text variant="heading-md">{title}</Text>
      </div>
      <Text
        as="div"
        className="simple-wysiwyg-content material-content"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </div>
  )
}

export default TextMateriContent
